import { render } from "./profile-menu.vue?vue&type=template&id=cbf9b7ca&scoped=true"
import script from "./profile-menu.vue?vue&type=script&lang=js"
export * from "./profile-menu.vue?vue&type=script&lang=js"

import "./profile-menu.vue?vue&type=style&index=0&id=cbf9b7ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf9b7ca"]])

export default __exports__